import React, { type FunctionComponent, useState } from 'react'
import { EditProductsModal } from 'domains/products/components/edit-products-modal/EditProductsModal'
import { ProductsEditProductActionSheet } from 'domains/products/components/search/components/edit-product-action-sheet/ProductsEditProductActionSheet'
import { useEditProducts } from 'domains/products/components/search/utils/useEditProducts.hooks'
import { usePartnerId, useRetailerId } from 'utils/routing/params.hooks'
import { EditInAssortmentModal } from 'domains/products/components/edit-in-assortment-modal/EditInAssortmentModal'

interface ProductsEditButtonAndModalProps {
  productId: string
  productName?: string
  productUpc?: string
  localeCode?: string
  showEditProduct?: boolean
  showInAssortment?: boolean
}

export const ProductsEditButtonAndModal: FunctionComponent<ProductsEditButtonAndModalProps> = ({
  productId,
  productName,
  productUpc,
  localeCode,
  showEditProduct = true,
  showInAssortment = false,
}) => {
  const warehouseId = useRetailerId()
  const partnerId = usePartnerId()
  const [showEditProductModal, setShowEditProductModal] = useState(false)
  const [showEditInAssortmentModal, setShowEditInAssortmentModal] = useState(false)

  const onSaveDepartmentAndAisle = useEditProducts({
    partnerId,
    warehouseId,
    setShowModal: setShowEditProductModal,
    localeCode,
    selectedCount: 1,
    isGlobalSelection: false,
    selectedKeys: [productId],
  })

  return (
    <React.Fragment>
      <ProductsEditProductActionSheet
        showEditProduct={showEditProduct}
        showInAssortment={showInAssortment}
        onEditProductClick={() => setShowEditProductModal(true)}
        onEditInAssortmentClick={() => setShowEditInAssortmentModal(true)}
      />

      {showEditProductModal && (
        <EditProductsModal
          retailerId={warehouseId}
          productCount={1}
          onClose={() => setShowEditProductModal(false)}
          onSave={onSaveDepartmentAndAisle}
        />
      )}

      {showEditInAssortmentModal && (
        <EditInAssortmentModal
          retailerId={warehouseId}
          sampleProduct={{
            name: productName,
            upc: productUpc,
          }}
          productIds={[productId]}
          onClose={() => setShowEditInAssortmentModal(false)}
        />
      )}
    </React.Fragment>
  )
}
